/* eslint-disable no-param-reassign */
// Redux Toolkit allows us to write "mutating" logic in reducers. It
// doesn't actually mutate the state because it uses the immer library,
// which detects changes to a "draft state" and produces a brand new
// immutable state based off those changes

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TableActionType = {
    name: string,
    query?: string,
    page?: number,
    orderBy?: string,
    orderDirection?: 'asc' | 'desc',
    filterValues?: {
        [key: string]: string | number | boolean
    }
};

type TableStateType = {
    options: {[key: string]: {
        query?: string,
        page?: number,
        orderBy?: string,
        orderDirection?: 'asc' | 'desc',
        filterValues?: {}
    }}
};

const initialState: TableStateType = {
    options: {}
};

const slice = createSlice({
    name: 'tables',
    initialState,
    reducers: {
        setTableOptions: (state, action: PayloadAction<TableActionType>) => {
            const { name, ...values } = action.payload;
            state.options[name] = { ...state.options[name], ...values };
        }
    }
});

export default slice;
